/* unplugin-vue-components disabled */import script from "./LateTax.vue?vue&type=script&setup=true&lang=js"
export * from "./LateTax.vue?vue&type=script&setup=true&lang=js"

import "./LateTax.vue?vue&type=style&index=0&id=5c61918f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c61918f"]])

export default __exports__